import { useAuthSSO } from '@vbee-holding/sso-pkg';

const useCustomSSO = () => {
  const { authSSO } = useAuthSSO();

  return { keycloak: authSSO, initialized: authSSO.initialized };
};

export default useCustomSSO;
